<template>
  <v-container
    fluid
    grid-list-md
    class="login">
    <v-layout
      column
      wrap
      justify-center>
      <v-form
        ref="form"
        v-model="valid">
        <v-flex md12>
          <v-card-text class="text-xs-center">
            <img
              class="login_logo"
              src="/img/galaxylogo.png">
            <div style="font-weight:600;">Sign in to AWS Galaxy</div>
          </v-card-text>
        </v-flex>
        <v-flex md12>
          <div
            v-if="(error) || loginfailed || loginerror || networkerror"
            class="error-message">
            <span style="font-weight:600">Error:</span>
            {{ networkerror }}
            {{ error }}
            {{ loginerror }}
          </div>
        </v-flex>
        <v-flex md12>
          <v-text-field
            v-model="input.username"
            :rules="nameRules"
            label="Username"
            required/>
        </v-flex>
        <v-flex md12>
          <v-text-field
            v-model="input.password"
            :type="'password'"
            :rules="passwordRules"
            label="Password"
            required
          />
        </v-flex>
        <v-flex
          offset-md8
          md4
          align-right>
          <v-btn
            :loading="loggingon"
            :class="{red:!valid, green:valid}"
            dark
            color="orange"
            @click="login()">Sign in</v-btn>
        </v-flex>
      </v-form>
    </v-layout>
  </v-container>
</template>

<script>
import { debug } from 'util'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'Login',
  data () {
    return {
      valid: false,
      authenticated: false,
      nameRules: [v => !!v || 'Username is required'],
      passwordRules: [v => !!v || 'Password is required'],
      error: '',
      input: {
        username: '',
        password: ''
      }
    }
  },
  computed: {
    ...mapState('auth', ['loggingon', 'networkerror', 'loginfailed', 'loginerror'])
  },
  methods: {
    ...mapActions({
      submit: 'auth/login',
      logout: 'auth/logout'
    }),
    login () {
      // apply validation
      // this.submit(this.input);

      this.error = ''

      if (!this.input.username && this.input.password) {
        this.error = 'Username is required'
      } else if (!this.input.password && this.input.username) {
        this.error = 'Password is required'
      } else if (!this.input.password && !this.input.username) {
        this.error = 'Username and Password is required'
      } else {
        this.submit(this.input)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#core-view {
  padding-bottom: 100px;
  height: auto !important;
}

#styled-input {
  height: 40px;
  font-size: 20pt;
}
.styled-input label[for] {
  height: 40px;
  font-size: 20pt;
}
.login {
  width: 450px;
  min-height: 300px;
  max-height: 500px;
  margin-top: 100px;
  border: 1px solid #a9a9a9;
  background: #ffff;
  padding: 50px 50px;
  color: #000;
  .layout {
    padding: 50px 0;
  }
}
.error-message{
  background: #fdf0f2;
  border: 1px dotted lightpink;
  padding: 11px 15px;
  font-size: 14px;
  color: red;
}
.login_logo {
  display: center;
  max-width: 20%; /* only this one important */
  margin-bottom: 1rem;

  /* border: solid 3px #fefefe; */
  border-radius: 3px;
  /* box-shadow: 0 0 0 1px rgba(10, 10, 10, 0.2); */
  line-height: 0;
}
.v-messages {
  color: red !important;
}

.theme--light.v-input:not(.v-input--is-disabled) input,
.theme--light.v-input:not(.v-input--is-disabled) textarea,
.v-text-field__slot .v-label {
  color: #000 !important;
}
</style>
